<template>
  <div>
    <b-button
      :variant="'outline-primary'"
      :class="
        'd-flex align-items-center justify-content-center ' + getButtonCss()
      "
      @click="toggleModal"
    >
      <i id="pencil" class="icon pencil alternate m-0" />
    </b-button>
    <FormClientSection
      v-if="isRightModal(1)"
      :isShown="showModal"
      title="Modifier un client"
      :action="this.$api.editClient"
      :clientId="this.objectId"
      id="1"
      @canceled="toggleModal"
      @successed-request="toggleModal"
    ></FormClientSection>
    <FormServerSection
      v-if="isRightModal(2)"
      :isShown="showModal"
      title="Modifier un serveur"
      :action="this.$api.editServer"
      :serverId="this.objectId"
      :clientId="clientId"
      id="2"
      @canceled="toggleModal"
      @successed-request="toggleModal"
    ></FormServerSection>
    <FormSoftwareSection
      v-if="isRightModal(3)"
      :isShown="showModal"
      title="Modifier un logiciel"
      :action="this.$api.editSoftware"
      :softwareId="this.objectId"
      :clientId="clientId"
      id="3"
      @successed-request="toggleModal"
      @canceled="toggleModal"
    ></FormSoftwareSection>
    <FormThresholdSection
      v-if="isRightModal(4)"
      :isShown="showModal"
      title="Modifier un message"
      :action="this.$api.editMessage"
      :softwareId="this.softwareId"
      :messageId="this.objectId"
      id="4"
      @successed-request="toggleModal"
      @canceled="toggleModal"
    ></FormThresholdSection>
  </div>
</template>

<script>
import FormClientSection from "@/sections/forms/FormClientSection.vue";
import FormServerSection from "@/sections/forms/FormServerSection.vue";
import FormSoftwareSection from "@/sections/forms/FormSoftwareSection.vue";
import FormThresholdSection from "@/sections/forms/FormThresholdSection.vue";
/**
 * @description Composante qui créer un bouton de modification avec un formulaire associé
 * @author Benjamin Caron
 * @vue-prop {Number} modalId - L'id du formulaire
 * @vue-prop {Number} objectId - L'id de l'objet à modifier
 * @vue-prop {Number} softwareId - L'id du logiciel lors des modifications d'un message
 * @vue-prop {String} border - La bordure du bouton
 * @vue-prop {Boolean} hasHover - Si le bouton a un hover
 * @vue-prop {String} clientId - L'id du client avec lequel lier l'objet (utilisé par les formulaires concernant les serveurs et les logiciels)
 * @vue-data {Boolean} showModal - Si la boîte modale est affichée
 */
export default {
  name: "GenericFormUpdate",
  components: {
    FormClientSection,
    FormServerSection,
    FormSoftwareSection,
    FormThresholdSection
  },
  props: {
    modalId: {
      type: Number,
      required: true
    },
    objectId: {
      type: Number,
      required: true
    },
    softwareId: {
      type: Number,
      required: false
    },
    border: {
      type: String,
      required: false,
      default: "border-1"
    },
    hasHover: {
      type: Boolean,
      required: false,
      default: true
    },
    clientId: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      showModal: false
    };
  },
  methods: {
    /**
     * @description Fonction qui indique si c'est la bonne boîte modale selon les props
     * @param {Number} modalId L'id de la boîte modale à tester
     * @returns {Boolean} Si c'est la bonne boîte modale
     */
    isRightModal(modalId) {
      return modalId == this.modalId;
    },
    /**
     * @description Fonction qui sert de toggle aux booléens indiquant si la boîte modale est affichée
     */
    toggleModal() {
      this.showModal = !this.showModal;
    },
    /**
     * @description Fonction qui donne des classes au bouton pour changer son affichage
     * @returns {String} La/les classes en texte
     */
    getButtonCss() {
      return this.hasHover ? this.border : this.border + " noHover";
    }
  }
};
</script>

<style scoped>
#pencil {
  padding-bottom: 25px !important;
}

button:hover {
  color: white;
}
</style>
